import React from "react";
import { connect } from "react-redux";
import { setSelectedMenu } from "../../Redux/Actions/actions";
import ReportMenu from "../../Components/Reports-component/ReportMenu";
import Calldetailsreports from "../../Components/Reports-component/Calldetailsreports";
import Agentskillsetreports from "../../Components/Reports-component/Agentskillsetreports";
import Agentlogin from "../../Components/Reports-component/AgentLogin";
import Outbounddetailedreport from "../../Components/Reports-component/Outbounddetailedreport";
import Outboundsummaryreport from "../../Components/Reports-component/Outboundsummaryreport";
import Servicereport from "../../Components/Reports-component/Servicereport";
import Yearlyreport from "../../Components/Reports-component/Yearlyreport";
import Skillsetsummary from "../../Components/Reports-component/Skillsetsummary";
import Weeklyreport from "../../Components/Reports-component/Weeklyreport";
import Monthlyreport from "../../Components/Reports-component/Monthlyreport";
import Quaterlyreport from "../../Components/Reports-component/Quaterlyreport";
import AgentLoginLogout from "../../Components/Reports-component/AgentLoginLogout";
import AgentStatusReport from "../../Components/Reports-component/AgentStatusReport";
import SessionReports from "../../Components/Reports-component/SessionReports";
import AgentReport from "../../Components/Reports-component/AgentReport";
import AgentStatisticsReport from "../../Components/Reports-component/AgentStatisticsReport";
import { TruckTrailer } from "@phosphor-icons/react";
import CallbackDetailsReport from "../../Components/Reports-component/CallbackDetailsReport";
import CampaignDetails from "../../Components/Reports-component/CampaignDetails";
import CampaignSummary from "../../Components/Reports-component/CampaignSummary";
import CallbackSummary from "../../Components/Reports-component/CallbackSummary";
import AgentPerformance from "../../Components/Reports-component/AgentPerformance";
import AgentMatrix from "../../Components/Reports-component/AgentMatrix";
import AverageAcrossChat from "../../Components/Reports-component/AverageAcrossChat";
import WhatsappChat from "../../Components/Reports-component/WhatsappChat";
import DispositionCode from "../../Components/Reports-component/DispositionCode";
import WhatsappOutboundReport from "../../Components/Reports-component/WhatsappOutboundReport";
import InboundAndOutbound from "../../Components/Reports-component/InboundAndOutbound";

const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
  };
};

const Reports = (props) => {
  return (
    <>
      {(() => {
        switch (props.selectedMenu) {
          case "ReportMenu":
            return <ReportMenu />;
          case "InteractionDetailsreports":
            return <Calldetailsreports />;
          case "Agentskillsetreports":
            return <Agentskillsetreports />;
          case "Agentlogin":
            return <Agentlogin />;
          case "Outbounddetailedreport":
            return <Outbounddetailedreport />;
          case "Outboundsummaryreport":
            return <Outboundsummaryreport />;
          case "Servicereport":
            return <Servicereport />;
          case "Yearlyreport":
            return <Yearlyreport />;
          case "Skillsetsummary":
            return <Skillsetsummary />;
          case "Weeklyreport":
            return <Weeklyreport />;
          case "Monthlyreport":
            return <Monthlyreport />;
          case "Quaterlyreport":
            return <Quaterlyreport />;
          case "Agentloginlogout":
            return <AgentLoginLogout />;
          case "Agentstatusreport":
            return <AgentStatusReport />;
          case "SessionReport":
            return <SessionReports show={TruckTrailer} />;
          case "AgentReports":
            return <AgentReport />;
          case "AgentStatisticsReport":
            return <AgentStatisticsReport />;
          case "CallbackReport":
            return <CallbackDetailsReport />;
          case "CampaignReport":
            return <CampaignDetails />;
          case "CampaignSummary":
            return <CampaignSummary />;
          case "CallbackSummary":
            return <CallbackSummary />;
          case "AgentPerformance":
            return <AgentPerformance />;
          case "AgentMatrix":
            return <AgentMatrix />;
          case "AverageAcrossChats":
            return <AverageAcrossChat />;
          case "WhatsappChat":
            return <WhatsappChat />;
          case "DispositionCode":
            return <DispositionCode />;
          case "WhatsappoutboundReport":
            return <WhatsappOutboundReport />;
             case "inboundOutboundPerformance":
            return <InboundAndOutbound />;
          default:
            return <ReportMenu />;
        }
      })()}
    </>
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
})(Reports);
